import getMappings from './mappings';

export function getOptions(type, entities) {
  const { label } = getMappings()[type];
  return entities.map(entity => ({
    label: label(entity),
    value: entity.id,
    data: entity,
  }));
}

export async function getSuggestedOptions(type, suggestions = []) {
  const { load } = getMappings()[type];
  const entities = suggestions.length > 0 ? await load() : [];
  const options = getOptions(type, entities);
  const filteredOptions = options.filter(option =>
    suggestions.includes(option.value),
  );
  // sort the results according to the array of suggested ids receveid by BE
  const sortedResults = filteredOptions.sort((a, b) => {
    const aId = Object.values(a)[1];
    const bId = Object.values(b)[1];
    return suggestions.indexOf(aId) - suggestions.indexOf(bId);
  });
  // this highlights the suggested options in green in the active view component
  const colouredfilteredOptions = sortedResults.map(option => ({
    ...option,
    color: '#d3f0dd',
  }));
  return colouredfilteredOptions;
}

export function filterOption(type, { label, data }, filter, limit = 3) {
  if (filter.length < limit) {
    return true;
  }
  const { fields } = getMappings()[type];
  const query = filter.toLowerCase();
  return (
    label.toLowerCase().includes(query) ||
    fields.some(
      field => data[field] && data[field].toLowerCase().includes(query),
    )
  );
}
